var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClientsQuotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 78,
    height: 74,
    viewBox: "0 0 78 74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#F4EAD6",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M17.926 33.984v6.218H33.46v33.46H0V33.984C0 21.357 3.635 11.982 10.8 6.115 15.755 2.057 22.03 0 29.447 0v17.924c-4.027 0-11.522 0-11.522 16.06zm55.309-16.06V0c-7.418 0-13.692 2.057-18.649 6.115-7.165 5.867-10.799 15.243-10.799 27.869v39.678h33.46v-33.46H61.712v-6.218c0-16.06 7.496-16.06 11.523-16.06z",
    transform: "translate(-700 -4824) translate(556 277) translate(64 4134) translate(0 372) translate(80 41)"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientsQuotes);
export default __webpack_public_path__ + "static/media/clients_quotes.863b84c5473608e2ac5fe68cc9237142.svg";
export { ForwardRef as ReactComponent };